import { FC, useMemo } from "react"
import CustomToolTip from "../CustomToolTip"
import { AllFilterType } from "./types";

interface Props {
    bands: {
        label: string;
        value: string;
    }[];
    allFilters: AllFilterType;
    onClick: (bandKey: string) => void;
    setAllFilters: (filters: AllFilterType) => void;
    applyFilter: (filters: AllFilterType) => void;
}

const BandsFilter: FC<Props> = ({ bands, allFilters, onClick, setAllFilters, applyFilter }) => {
    const selectedBands = useMemo(() => allFilters?.bandsFilter || [], [allFilters?.bandsFilter])

    const handleBandClick = (band) => {
        onClick(band.value); // still triggers external logic

        const existingBands = allFilters.bandsFilter || [];

        const updatedBands = existingBands.includes(band.value)
            ? existingBands.filter((b) => b !== band.value) // remove if already selected
            : [...existingBands, band.value];               // add if not selected

        const all_filters: AllFilterType = {
            ...allFilters,
            bandsFilter: updatedBands
        };

        setAllFilters(all_filters);
        applyFilter(all_filters)
    }


    return (
        <div className={`bands__filters__container ${(bands?.length === 0 || !bands) ? 'd-none' : ''}`}>
            {bands?.map((band) => (
                <CustomToolTip title={band.label} placement="top">
                    <button
                        key={band?.value}
                        className={`bands__filter__button ${selectedBands?.some(selected => selected.replace('-band', '') === band.value) ? 'bands__active': ''}`}
                        onClick={() => { handleBandClick(band) }}
                    >
                        {band?.label.split(' ')[0]}
                    </button>
                </CustomToolTip>
            ))
            }
        </div >
    )
}

export default BandsFilter